<template>
  <div class="index">
    <!-- 顶部 -->
    <div class="show_top clearbox">
      <div class="topmain clearbox fr">
        <a class="fl" v-for="(x,i) in toprightArr" :key="i" :id="x.id" :href="x.href" :target="x.target" @click="goRouter(x.gorouter)">
          <i class="iconfont">{{x.icon}}</i>{{x.str}}
          <div class="hide" v-if="x.bhtml && x.imgstr">
            <div>
              <img :src="x.imgstr" />
              <b style="font-size:12px;" v-html="x.bhtml"></b>
            </div>
            <div v-if="x.imgstr2" style="margin-left:20px;">
              <img :src="x.imgstr2" />
              <b style="font-size:12px;" v-html="x.bhtml2"></b>
            </div>
          </div>
        </a>
      </div>
    </div>
    <!-- 主体 -->
    <div class="show_main">
      <!-- <a class="main_logo" href="http://sp.3g48.com" title="竞成全国远程视频真人在线互动平台"></a> -->
      <img class="main_logo" :src="siteInfos.homeLogoId" alt="">
      <!-- 搜索表单 -->
      <el-form  class="searchbox" ref="selectform" :model="selectform">
        <el-row style="border:1px solid #1E9FFF">
          <el-col :span="4">
            <el-select class="fuwutype" v-model="selectform.fuwutype" placeholder="请选择服务">
              <el-option v-for="(x,i) in fuwuList" :key="i" :label="x.name" :value="x.value"></el-option>
            </el-select>
          </el-col>
          <el-col :span="18">
            <el-input v-model="selectform.keywords" placeholder="请输入内容"></el-input>
          </el-col>
          <el-col :span="2">
            <el-button class="searchbutton" type="primary" icon="el-icon-search" @click="submitSearch()"></el-button>
          </el-col>
        </el-row>
      </el-form>
      <!-- 内容 -->
      <div class="flexbox">
        <div class="box" v-for="(x,i) in fuwuArr" :key="i">
          <div @click="navToHandler(x.route)">
            <img :src="x.src">
            <p class="tit" :style="'color:'+x.color">{{x.tit}}</p>
            <p class="desc">{{x.desc}}</p>
          </div>
        </div>
      </div>
      <ul class="addlink clearfix" >
        <li class="link">
          <a href="javascript:;" class="add-link"><i class="iconfont">&#xe613;</i></a>
        </li>
        <li class="link">
          <a href="javascript:;" class="add-link"><i class="iconfont">&#xe613;</i></a>
        </li>
        <li class="link">
          <a href="javascript:;" class="add-link"><i class="iconfont">&#xe613;</i></a>
        </li>
        <li class="link">
          <a href="javascript:;" class="add-link"><i class="iconfont">&#xe613;</i></a>
        </li>
      </ul>
    </div>
    <!-- 底部 -->
    <div class="show_footer">
      <!-- <span>版权所有 ©{{siteInfos.copyrightOwner}}</span>
      <span><a href="https://beian.miit.gov.cn" target="_blank">{{siteInfos.caseNumber}}</a></span>
      <span><a href="https://beian.miit.gov.cn" target="_blank">{{siteInfos.caseNumber_1}}</a></span>
      <span>您是本网站第 <i class="red">{{viewNumber}}</i> 位访问者</span> -->
      <div>
        <span>
          版权所有 ©{{siteInfos.copyrightOwner}}&nbsp;&nbsp;&nbsp;
          <a href="http://www.ccopyright.com.cn" target="_blank">计算机软件著作权登记证书软著登字第{{siteInfos.computerSoftwareCopyrightNo}}号</a>
          &nbsp;&nbsp;&nbsp;
          <a href="https://sbj.cnipa.gov.cn/sbj/index.html" target="_blank">商标注册证第68407202号</a>
        </span>
      </div>
      <div>
        <span>
          <a href="https://beian.miit.gov.cn" target="_blank">{{siteInfos.caseNumber}}</a>&nbsp;&nbsp;&nbsp;
          <a href="https://beian.miit.gov.cn" target="_blank">{{siteInfos.caseNumber_1}}</a>&nbsp;&nbsp;&nbsp;
          <a href="https://tsm.miit.gov.cn" target="_blank">{{siteInfos.icpEdiNo}}</a>&nbsp;&nbsp;&nbsp;
          <a :href="'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode='+siteInfos.filingNo" target="_blank">川公网安备{{siteInfos.filingNo}}号</a>
        </span>
      </div>
      <div>
        <span>
          全国客服：<a>400&nbsp;–&nbsp;6968&nbsp;–&nbsp;688</a>&nbsp;&nbsp;&nbsp;
          监督投诉：<a>jingcheng@3g48.com</a>&nbsp;&nbsp;&nbsp;
          您是本网站第&nbsp;<i class="red">{{viewNumber}}</i>&nbsp;位访问者
        </span>
      </div>
    </div>
    <!-- 背景动画 -->
    <div class="show_bg" id="show_bg">
      <div id="intro">
      </div>
    </div>
  </div>
</template>

<script>
import { fuwuList } from '@/publicData/fuwuList'
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      fuwuList: fuwuList,
      selectform: {
        fuwutype: 'zhaopin',
        keywords: '',
      },//查询表单
      viewNumber: 1,//访问次数
      AreaId: '',//登录用户的区域id
      
      toprightArr: [
        {gorouter:'/login',icon:'\ue61c',str:'登录',},
        {gorouter:'/register',icon:'\ue612',str:'注册',},
        {href:'https://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/JCGF_for_Windows_V3.38.2.1.exe',target:'_blank',icon:'\ue786',str:'PC端下载',},
        {href:'javascript:;',id:'App1',icon:'\ue786',str:'APP下载',imgstr:require('./images/androiddownload.png'),bhtml:'安卓扫描二维码<br>苹果搜竞成云视频'},
        {href:'javascript:;',id:'App2',icon:'\ue786',str:'码上',imgstr:require('./images/ewm_ms_ios.png'),bhtml:'码上IOS',imgstr2:require('./images/ewm_ms_android.png'),bhtml2:'码上Android'},
        {href:'https://cd-jinchen-public.oss-cn-zhangjiakou.aliyuncs.com/JCGF_for_Mac_V3.37.1.21.dmg',target:'_blank',icon:'\ue786',str:'Mac端下载',},
        {href:'javascript:;',id:'chengxu',icon:'\ue69b',str:'小程序',imgstr:require('./images/ewmxcx_01.jpg'),bhtml:'微信小程序'},
        {href:'javascript:;',id:'gongzhong',icon:'\ue63f',str:'公众号',imgstr:require('./images/ewmgzh_01.jpg'),bhtml:'微信公众号'},
        {href:'javascript:;',id:'weibo',icon:'\ue607',str:'微博',imgstr:require('./images/ewm_02.jpg'),bhtml:'竞成微博'},
        // {href:'http://www.3g48.com/about/',target:'_blank',id:'help',icon:'\ue619',str:'帮助中心'},
        {gorouter:'/articleDetail?catalog=signUp',icon:'\ue619',str:'帮助中心',},
      ],

      siteInfos: {
        copyrightOwner: '成都竞成人力资源服务股份有限公司',
        computerSoftwareCopyrightNo: '10328624',
        caseNumber: '蜀ICP备11025845号',
        caseNumber_1: '蜀ICP备11025845号-1',
        icpEdiNo: 'ICP/EDI川B2-20220159号',
        filingNo: '51010402001408',
        caseTime: '2017-2022',
        homeLogoId: require('@/views/showpage/images/main_logo.png'),
      },
    }
  },
  computed: {
    fuwuArr() {
      return [
        {src:require('./images/logo2.png'),tit:'就业视吧',desc:'远程视频招聘求职',color:'#0098FF',route:'fuwu?areaId='+this.AreaId+'&type=zhaopin&page=1',},
        {src:require('./images/logo3.png'),tit:'在线培训',desc:'教育培训职场充电',color:'#EBAB00',route:'fuwu?areaId='+this.AreaId+'&type=peixun&page=1',},
        {src:require('./images/logo4.png'),tit:'创新创业',desc:'项目资金众创空间',color:'#44C0B6',route:'fuwu?areaId='+this.AreaId+'&type=zhaoshang&page=1',},
        {src:require('./images/logo5.png'),tit:'法律维权',desc:'律师真人在线咨询',color:'#FF6833',route:'fuwu?areaId='+this.AreaId+'&type=lvshi&page=1',},
        {src:require('./images/logo6.png'),tit:'巩固脱贫',desc:'巩固拓展脱贫成果',color:'#F6657E',route:'welcome',},
        {src:require('./images/logo7.png'),tit:'乡村振兴',desc:'旅游美食医疗健康',color:'#40C6C4',route:'fuwu?areaId='+this.AreaId+'&type=lvyou&page=1',},
        {src:require('./images/logo8.png'),tit:'人事人才',desc:'人才引进高级猎头',color:'#52C870',route:'renshi',},
        {src:require('./images/logo9.png'),tit:'OA系统',desc:'办公自动化AI服务',color:'#7163F7',route:'oa',},
      ]
    }
  },
  methods: {
    ...mapMutations(['siteNavs_save', 'defaultLogo_save', 'logout']),
    goRouter(str) {
      if (str == '/logout') {
        this.$confirm('是否退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api._user_cancellation().then(res => {
            if (res.data.status === 0) {
              this.logout()
              this.$message.success('注销成功')
              this.$router.push('/login')
            } else { this._status(res.data) }
          })
        }).catch(() => {})
      } else {
        this.$router.push(str)
      }
    },
    submitSearch() {
      let { fuwutype, keywords } = this.selectform
      console.log(fuwutype, keywords)
      if (keywords) {
        let route = 'fuwu?areaId='+this.AreaId+'&type='+fuwutype+'&page=1&key='+keywords
        // console.log(route)
        this.$router.push(route)
      } else {
        this.$message.warning('请输入内容')
      }
    },
    navToHandler(str) {
      if (str === 'welcome') {
        this.$api.get_user_login_info().then(res=> {
          if (res.data.status === 0) {
            localStorage.setItem('loginData', res.data.data)
            let _R = JSON.parse(res.data.data)
            let {
              admin,
              organization,
              personal,
            } = _R
            personal
              ? str = 'userInfo'
              : organization
                ? str = 'companyInfo'
                : admin
                  ? str = 'welcome'
                  : ''
            this.$router.push(str)
          } else { this._status(res.data) }
        })
      } else if (str === 'oa') {
        // window.open('http://oa.3g48.com/')
        this.$message.warning('OA系统正在升级优化中')
      } else {
        this.$router.push(str)
      }
    },
    getViewNumber() {
      let rD = {
        id: this.AreaId,
      }
      this.$api.getViewNumber(rD).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c浏览次数:`, 'color: #f00;', _R)
          this.viewNumber = _R[0].viewNumber
        } else { this._status(res.data) }
      })
    },
    getSiteInfo() { // 获取分站信息
      this.$api.getSystem(this.AreaId).then(res => {
        if (res.data.status === 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c分站信息:`, 'color: #f00;', [_R])
          this.siteInfos = {
            // zhu: {
            //   logo: _R.logoId ? this._img_handler(_R.logoId) : require('@/assets/logo.png'),
            //   systemName: _R.title || '码上-3G48-AI智慧大数据云视频平台',
            //   zhuban: _R.holdSide || '竞成股份',
            //   weiquan: _R.maintain || '成竞律师',
            // },
            // rsrc: {
            //   logo: _R.rsrcLogo ? this._img_handler(_R.rsrcLogo) : require('@/assets/logo.png'),
            //   systemName: _R.rsrcTitle || '码上-3G48-AI智慧大数据云视频平台',
            //   zhuban: _R.rsrcHoldSide || '竞成股份',
            //   weiquan: _R.rsrcMaintain || '成竞律师',
            // },
            copyrightOwner: _R.copyrightOwner || '成都竞成人力资源服务股份有限公司',
            computerSoftwareCopyrightNo: '10328624',
            caseNumber: _R.caseNumber || '蜀ICP备11025845号',
            caseNumber_1: _R.caseNumber_1 || '蜀ICP备11025845号-1',
            icpEdiNo: 'ICP/EDI川B2-20220159号',
            filingNo: '51010402001408',
            caseTime: _R.caseTime || '2017-2022',
            homeLogoId: _R.homeLogoId ? this._img_handler(_R.homeLogoId) : require('@/views/showpage/images/main_logo.png'),
          }
          // {
          //   copyrightOwner: '成都竞成人力资源服务股份有限公司',
          //   computerSoftwareCopyrightNo: '10328624',
          //   caseNumber: '蜀ICP备11025845号',
          //   caseNumber_1: '蜀ICP备11025845号-1',
          //   icpEdiNo: 'ICP/EDI川B2-20220159号',
          //   filingNo: '51010402001408',
          //   caseTime: '2017-2022',
          //   homeLogoId: require('@/views/showpage/images/main_logo.png'),
          // }
          this.siteNavs_save(_R.nameAndUrlList)
          // console.log(`%crsrc外链:`, 'color: #f00;', _R.nameAndUrlList)

          if (_R.logoId) {
            this.defaultLogo_save(this._img_handler(_R.logoId))
          } else {
            this.defaultLogo_save(require('@/assets/logo.png'))
          }
          
          this.toprightArr[3].imgstr = _R.videoAppDownloadImgId ? this._img_handler(_R.videoAppDownloadImgId) : require('./images/androiddownload.png')
          this.toprightArr[3].bhtml = (_R.videoAppDownloadDescription || '安卓扫描二维码') + '<br>' + (_R.videoAppDownloadDescription2 || '苹果搜竞成云视频')
          this.toprightArr[4].imgstr = _R.appIosDownloadImgId ? this._img_handler(_R.appIosDownloadImgId) : require('./images/ewm_ms_ios.png')
          this.toprightArr[4].imgstr2 = _R.appAndroidDownloadImgId ? this._img_handler(_R.appAndroidDownloadImgId) : require('./images/ewm_ms_android.png')
          this.toprightArr[4].str = _R.appName || '码上'
          this.toprightArr[4].bhtml = (_R.appName || '码上') + 'IOS'
          this.toprightArr[4].bhtml2 = (_R.appName || '码上') + 'Android'
          this.toprightArr[6].imgstr = _R.smallSoftImgId ? this._img_handler(_R.smallSoftImgId) : require('./images/ewmxcx_01.jpg')
          this.toprightArr[7].imgstr = _R.officialAccountImgId ? this._img_handler(_R.officialAccountImgId) : require('./images/ewmgzh_01.jpg')
          this.toprightArr[8].imgstr = _R.weiboImgId ? this._img_handler(_R.weiboImgId) : require('./images/ewm_02.jpg')

        } else { this._status(res.data) }
      })
    },
    init() {
      this.$api.get_user_login_info().then(res => {
        if (res.data.status == 0) {//用户已登陆
          localStorage.setItem('loginData', res.data.data)
          let myinfo = {gorouter:'/welcome',icon:'\ue616',str:'我的',}
          let logout = {gorouter:'/logout',icon:'\ue6e2',str:'注销',}
          this.toprightArr.splice(0, 2, myinfo, logout)
          
          this.AreaId = this.pageAreaId_x
          if (this.AreaId === '' || this.AreaId === null) {
            this.AreaId = this.userInfo && this.userInfo.areaId
          }
          if (this.AreaId === '' || this.AreaId === null) {//管理员没有区域id，赋值为登陆地的区域id
            this.$api.position_search({}).then(res => {
              this.AreaId = res.data.data
              this.$store.commit('setPageAreaId', this.AreaId)
            })
          } else {
            this.getViewNumber()
            this.getSiteInfo()
          }
        } else {//用户未登录
          this.AreaId = this.pageAreaId_x
          if (this.AreaId === '' || this.AreaId === null) {//没有区域id，赋值为登陆地的区域id
            this.$api.position_search({}).then(res => {
              this.AreaId = res.data.data
              this.$store.commit('setPageAreaId', this.AreaId)
            })
          } else {
            this.getViewNumber()
            this.getSiteInfo()
          }
        }
      })
    },
  },
  created() {
    this.init()
  },
}
</script>

<style lang='scss' scoped>
/deep/ .searchbox input{font-size: 16px;width: 100%;height: 50px!important;line-height: 50px!important;border: none;}

.show_bg{position: fixed;z-index: -1;left: 0;top: 0;width: 100%;height: 100%;background: url('./images/bg.jpg') no-repeat center center / 100% 100%;}

/* 顶部 */
.show_top{width: 100%;line-height: 25px;height: 25px;}
.show_top .topmain{margin-top: 5px;color: #333;height: 100%;}
.show_top .topmain a {cursor: pointer;margin-right: 15px;font-size: 14px;color: #666666;position: relative;}
.show_top .topmain a i{margin-right: 5px;}
.show_top .topmain a i :after{display: none;margin-right: 5px;}
.show_top .topmain #App1:hover .hide,
.show_top .topmain #App2:hover .hide,
.show_top .topmain #chengxu:hover .hide,
.show_top .topmain #gongzhong:hover .hide,
.show_top .topmain #weibo:hover .hide,
.show_top .topmain #help:hover .hide{display: flex;justify-content: space-between;align-items: center;}
.show_top .topmain a .hide{display: none;padding: 15px;left: -35px;position: absolute;min-width: 140px;line-height: 16px;border: 1px solid #1E9FFF;box-shadow: 0 5px 5px 5px rgba(0,0,0,0.1);text-align: center;background-color: #fff;}
.show_top .topmain a .hide img{width: 140px;height: 140px;}
/* 顶部结束 */

/* 主体 */
.show_main{width: 1100px;height: 592px;position: fixed;z-index: 1;left: 50%;margin-left: -550px;top: 50%;margin-top: -280px;}
.show_main .main_logo{width: 343px;height: 104px;display: block;margin-left: auto;margin-right: auto;margin-bottom: 30px;z-index: 22;} // background: url("./images/main_logo.png") no-repeat;
.show_main .searchbox{width: 100%;height: 50px;margin-bottom: 30px;box-shadow: 0px 5px 5px 5px rgba(0,0,0,0.05);background-color: #ffffff;}
.show_main .searchbox .searchbutton{width: 100%;height: 50px;font-size: 20px;border-radius: 0px;}
.show_main .flexbox{display: flex;flex-wrap: wrap;width: 100%;}
.show_main .flexbox .box{width: 25%;height: 150px;padding-bottom: 30px;text-align: center;}
.show_main .flexbox .box div{margin: 0px auto;height: 150px;width: 120px;cursor: pointer;}
.show_main .flexbox .box div img{height: 80px;width: 79px;}
.show_main .flexbox .box div .tit{line-height: 40px;font-size: 26px;}
.show_main .flexbox .box div .desc{line-height: 40px;font-size: 14px;color: #bbb;}
.show_main .addlink{width: 100%;display: flex;justify-content: space-between;}
.show_main .addlink .link{width: 23%;box-sizing: border-box;position: relative;}
.show_main .addlink .link a{display: flex;width: 100%;justify-content: center;align-items: center;font-size: 14px;background-color: rgba(255,255,255,0.2);border: 1px solid #ffffff;transition: all .2s;height: 40px;color: #999999;box-shadow: 0 0px 5px 5px rgba(0,0,0,0.02);}

/* 底部 */
.show_footer{line-height: 1.6;font-size: 14px;color: #999999;text-align: center;padding: 5px;position: fixed;bottom: 0;left: 0;right: 0;z-index: 1;}
.show_footer span{padding: 0px 5px;}
.show_footer span a{color: #999999;}
.show_footer span i{font-style: normal;}
</style>